import { Vue, prop } from "vue-class-component";
import environment from "@/config";


export class Props {
    options = prop({
        type: Object,
    })
}
export default class CemsInfoComponent extends Vue.with(Props) {

    data: any = [];

    mounted(): void {
        this.data = [
            {
                label: environment.mappings?.monitor?.info?.equipment ?? "Equipment",
                icon: 'settings',
                value: this.options.equipment,
            },
            {
                label: environment.mappings?.monitor?.info?.sensor ?? "Sensor",
                icon: 'sound-wave',
                value: this.options.sensor,
            }
        ]
    }

}